export default (to, from, next) => {
    if (import.meta.env.MODE === 'development') {
        next();
    } else {
        next({ name: 'home' });
    }
};
